import { render, staticRenderFns } from "./BlockDriver.vue?vue&type=template&id=4c5f98f2&"
import script from "./BlockDriver.vue?vue&type=script&lang=js&"
export * from "./BlockDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports